"use client";

import { Component } from "react";

import { reportBoundaryError } from "@/lib/client-boundary-error";

import type { ReactNode } from "react";

/** Optional identity must never take the independent game and asset wallets down. */
export class GlyphSessionBoundary extends Component<
  {
    children: ReactNode;
    onFailure: () => void;
  },
  { failed: boolean }
> {
  state = { failed: false };
  static getDerivedStateFromError() {
    return { failed: true };
  }
  componentDidCatch(error: unknown) {
    void reportBoundaryError(error, "glyph");
    this.props.onFailure();
  }
  render() {
    return this.state.failed ? null : this.props.children;
  }
}
